import { render, staticRenderFns } from "./v-contact-widget.vue?vue&type=template&id=b7cd2612&scoped=true&"
import script from "./v-contact-widget.vue?vue&type=script&lang=js&"
export * from "./v-contact-widget.vue?vue&type=script&lang=js&"
import style0 from "./v-contact-widget.vue?vue&type=style&index=0&id=b7cd2612&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cd2612",
  null
  
)

export default component.exports